import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { SystemChannelMetaDataCustom } from '../../types';
import { PB_CHANNELS } from '../../constants';
import { getErrorText } from '../helpers';
import { RootState } from '../../..';

type Params = { roomId: string; custom: SystemChannelMetaDataCustom };
type Response = Pubnub.SetChannelMetadataResponse<SystemChannelMetaDataCustom>;

export const setSystemChannelMetadata = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/setSystemChannelMetadata',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result: Pubnub.SetChannelMetadataResponse<SystemChannelMetaDataCustom> =
          await pubnubReducer.pubnub.objects.setChannelMetadata({
            channel: `${data.roomId}.${PB_CHANNELS.SYSTEM}`,
            data: { custom: data.custom },
          });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
